import {
  Box,
  Center,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Input,
  InputGroup,
  InputLeftElement,
  SlideFade,
  Stack,
  Switch,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Container from '../../components/Container';
import { BsArrowLeft } from 'react-icons/bs';
import { PrimaryButton } from '../../components/CustomButton';
import { RiUser3Fill } from 'react-icons/ri';
import { BsPhone } from 'react-icons/bs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { inviteGuest } from './service/inviteGuest';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import ShareInviteLink from './components/ShareInviteLink';
import { PROTECTED_PATHS } from '../../app/constants';
import ShareModal from './components/ShareModal';
import CustomModal from '../../components/CustomModal';
import CustomizeVisitModal from './components/CustomizeVisitModal';
import { infoNotifier } from '../../components/NotificationHandler';
import { pickContactFromPhone } from './service/addFromContact';
import { timeout } from '../../components/utils/timeout';
import PickContactFromPhoneWarning from './components/PickContactFromPhoneWarning';
// import CustomizeVisit from './components/CustomizeVisit';

const InviteGuest = () => {
  const today = new Date();
  const { MY_ESTATE } = PROTECTED_PATHS;
  const navigate = useNavigate();
  const url = window?.location.href;
  const urlString = new URL(url);
  const guestName = urlString?.searchParams?.get('name') || '';
  const guestPhone = urlString?.searchParams?.get('phone')?.trim() || '';
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [allowCompany, setAllowCompany] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestCode, setGuestCode] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [disable, setDisable] = useState(true);
  const [name, setName] = useState(guestName);
  const [phone, setPhone] = useState(guestPhone);

  const initialValues = {
    tenantCode: sessionStorage.getItem('tenantCode'),
    userId: sessionStorage.getItem('userId'),
    oneTimeVisit: true,
    allowCompany,
    startDate: dayjs(today).format('YYYY-MM-DD'),
    endDate: dayjs(today).format('YYYY-MM-DD'),
    // days: [],
  };

  const [values, setValues] = useState(initialValues);

  const handleStartDate = (date) => {
    setStartDate(date);
    const formated = dayjs(date).format('YYYY-MM-DD');
    const formatedDate = formated;

    setValues((values) => ({
      ...values,
      startDate: formatedDate,
    }));
  };
  const handleEndDate = (date) => {
    setEndDate(date);
    const formated = dayjs(date).format('YYYY-MM-DD');
    const formatedDate = formated;

    setValues((values) => ({
      ...values,
      endDate: formatedDate,
    }));
  };

  const handleAllowCompany = () => {
    setAllowCompany(!allowCompany);
    setValues((values) => ({ ...values, allowCompany: !allowCompany }));
  };

  const handleInvite = () => {
    if (disable) {
      infoNotifier('Enter Guest name and Phone number first');
      return;
    }
    const payload = { ...values, name, phone };
    inviteGuest(payload, setLoading, setGuestCode, onOpen, onClose);
  };

  const handlepickContactFromPhone = () => {
    pickContactFromPhone(setName, setPhone);
  };

  useEffect(() => {
    name && phone ? setDisable(false) : setDisable(true);
  }, [name, phone]);

  const handleShareClose = () => {
    onClose();
    timeout(() => navigate(MY_ESTATE), 1000);
  };

  return (
    <SlideFade in={true} offsetY='500px'>
      <Container px='5%'>
        <Stack pt='3vh'>
          <Flex
            py='4'
            mb='5'
            shadow='sm'
            align='center'
            justify='space-between'
          >
            <Box>
              <Link to={PROTECTED_PATHS.MY_ESTATE}>
                <BsArrowLeft size={25} />
              </Link>
            </Box>
            <Text
              flex={0.65}
              fontSize='16px'
              fontWeight='600'
              color='primaryDark'
            >
              Invite Guest
            </Text>
          </Flex>

          <Center py='3'>
            <PrimaryButton
              btnText='Add from contact'
              onClick={handlepickContactFromPhone}
              w='80%'
              maxW='300px'
            />
          </Center>
          <HStack>
            <Divider />
            <Text>Or</Text>
            <Divider />
          </HStack>
          <FormControl isRequired>
            <Stack spacing='5' pb='5'>
              <Box>
                <FormLabel htmlFor='name' mb='0'>
                  Guest name
                </FormLabel>
                <InputGroup>
                  <InputLeftElement children={<RiUser3Fill />} />
                  <Input
                    id='name'
                    name='name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder='Ciroma'
                  />
                </InputGroup>
              </Box>

              <Box>
                <FormLabel htmlFor='phone' m='0'>
                  Guest Phone number
                </FormLabel>
                <InputGroup>
                  <InputLeftElement children={<BsPhone />} />
                  <Input
                    name='phone'
                    id='phone'
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder='08055...'
                    // type='number'
                  />
                </InputGroup>
              </Box>
            </Stack>
          </FormControl>

          <Flex>
            <Text pr='3'>Allow Company</Text>
            <Switch isChecked={allowCompany} onChange={handleAllowCompany} />
          </Flex>
          <HStack
            justify='space-between'
            gap={['0.5rem', '1rem']}
            py='2'
            wrap='wrap'
          >
            <PrimaryButton
              size='sm'
              w={['140px', '160px']}
              btnText='One Time Visit'
              rightIcon={<Checkbox isChecked={true} />}
            />
            <CustomModal
              size='sm'
              customVisit
              name={name}
              phone={phone}
              buttonProps={{
                size: 'sm',
                bg: 'primaryDark',
                w: ['140px', '160px'],
                // isDisabled: disable,
              }}
              btnTitle='Custom Visit'
            >
              <CustomizeVisitModal name={name} phone={phone} />
            </CustomModal>
          </HStack>

          <Flex justify='space-between' wrap='wrap' gap='1rem' py='5'>
            <Stack spacing='0'>
              <Text>Start date</Text>
              <DatePicker
                minDate={new Date()}
                dateFormat={'dd/MM/yyyy'}
                selected={startDate}
                onChange={(date) => handleStartDate(date)}
              />
            </Stack>
            <Stack spacing='0'>
              <Text>End date</Text>
              <DatePicker
                minDate={new Date()}
                selected={endDate}
                dateFormat='dd/MM/yyyy'
                onChange={(date) => handleEndDate(date)}
              />
            </Stack>
          </Flex>
          <Box textAlign='center'>
            <PrimaryButton
              w='80%'
              onClick={handleInvite}
              isLoading={loading}
              btnText='Send Invite'
            />
          </Box>
        </Stack>
        <ShareModal
          size='xs'
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={handleShareClose}
        >
          <ShareInviteLink onClose={onClose} guestCode={guestCode} />
        </ShareModal>
        <PickContactFromPhoneWarning />
      </Container>
    </SlideFade>
  );
};

export default InviteGuest;
